module.exports = __webpack_public_path__ + "img/index-pic3.993ac76a.webp";